import { Alert, Stack } from '@mui/material';
import { toTitleCase } from '@/utils';
import { TabPill } from '../styles';

type RoleProps = {
  roles: string[];
  selectedRole: string;
  handleSelectedRole: (role: string) => void;
};

export const UserRoles = ({ roles, selectedRole, handleSelectedRole }: RoleProps) => {
  if (!roles || !Array.isArray(roles) || roles.some((role) => typeof role !== 'string')) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        An error occurred while fetching roles
      </Alert>
    );
  }

  if (roles.length === 0) {
    return (
      <Alert severity="info" sx={{ mb: 2 }}>
        User does not have any roles
      </Alert>
    );
  }

  return (
    <Stack spacing={1} direction="row" flexWrap="wrap">
      {roles.map((role) => (
        <TabPill
          key={role}
          selected={selectedRole === role}
          onClick={() => handleSelectedRole(role)}
        >
          {toTitleCase(role)}
        </TabPill>
      ))}
    </Stack>
  );
};
